//*
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
//
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs, { Dayjs } from "dayjs";
// after
import { Link as RLink } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
//import styles from "./User.module.css";
import { SerializedError } from "../../util/types";
import {
    FileMetadataItem,
    FileMetadataEditRequest,
    toEditRequest,
} from "./fileSlice";
import { useFileViewQuery, useFileEditMutation } from "../../api/file";
import { Contact } from "../contact/contactSlice";
import ContactComplete from "../contact/AutoComplete";
import EditBar from "./EditBar";

/*
export default function FileEditLayout() {
    let { id } = useParams();
    const idStr = id ? id : "";
    //const file = useAppSelector(selectTicket(idStr));
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useFileViewQuery(idStr, { refetchOnMountOrArgChange: true });
    let content: React.ReactNode;

    if (isLoading) {
        content = <FileViewerLoading />;
    } else if (isFetching) {
        content = <FileViewerFetching />;
    } else if (isSuccess) {
        content = <FileEditDisplay file={toEditRequest(data.file)} />;
    } else if (isError) {
        content = <FileViewerError error={error} />;
    }
    return <Box>{content}</Box>;
}
// */
export default function FileEditDisplay() {
    //console.log("in file edit display", file);
    const navigate = useNavigate();
    let { id } = useParams();
    const idv = id ? id : null;
    const idStr = id ? id : "";
    let [fmer, setFMER] = React.useState<FileMetadataEditRequest | null>(null);
    console.log("202511212228", fmer);
    const [updateFile, { isLoading: isUpdating }] = useFileEditMutation();
    const onSave = () => {
        if (fmer) {
            updateFile(fmer)
                .unwrap()
                .then((fullfilled) => {
                    if (fullfilled && fullfilled.file) {
                        navigate("/file/view/" + fullfilled.file.metadata.id);
                    }
                });
        }
        console.log("2024101608254", fmer);
    };
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useFileViewQuery(idStr, { refetchOnMountOrArgChange: true });
    let content: React.ReactNode;

    if (isLoading) {
        content = <FileViewerLoading />;
    } else if (isFetching) {
        content = <FileViewerFetching />;
    } else if (isSuccess) {
        content = (
            <FileEditForm
                fmer={toEditRequest(data)}
                onSave={onSave}
                onFMERChange={(fmer: FileMetadataEditRequest) => {
                    console.log("putting fmer", fmer);
                    setFMER(fmer);
                }}
            />
        );
    } else if (isError) {
        content = <FileViewerError error={error} />;
    }
    return <>{content} </>;
}

interface ChildProps {
    fmer: FileMetadataEditRequest;
    onFMERChange: (fmer: FileMetadataEditRequest) => void;
    onSave: () => void;
}
export function FileEditForm({ fmer, onFMERChange, onSave }: ChildProps) {
    console.log("202511212216 - FileEditForm", fmer);
    const theme = useTheme();
    const sx = {
        backgroundColor: "#eeeeee",
        display: "flex",
        height: theme.mixins.toolbar.minHeight,
        width: "100%",
        paddingLeft: 3,
        paddingRight: 8,
        alignItems: "center",
        zIndex: theme.zIndex.appBar,
    };

    const [nameV, setName] = useState<string>(fmer.name);
    const onFilenameChange = (t: string) => {
        //ticketV.title = t;
        setName(t);
        let f = getForm();
        f.name = t;
        onFMERChange(f);
    };
    const initialCreated = fmer.metadata.created.ts;
    const [created, setCreated] = useState<Dayjs | null>(
        initialCreated ? dayjs(initialCreated) : null,
    );
    const onSetCreated = (d: Dayjs | null) => {
        //ticketV.start = d ? d.toDate().toISOString() : null;
        let created = setCreated(d);
        let f = getForm();
        f.metadata.created.ts = d
            ? d.toDate().toISOString()
            : new Date().toISOString();
        onFMERChange(f);
    };
    const onDeleteCreated = () => {
        //ticket.start = null;
        let created = setCreated(null);
        let f = getForm();
        f.metadata.created.ts = new Date().toISOString();
        onFMERChange(f);
    };
    // contacts
    let initContacts: /* Contact[] */ { [key: string]: Contact } =
        fmer.contacts; //fmer ? fmer.contacts : {};
    console.log("this is initContacts: ", initContacts);
    let [contactsValue, setContacts] = React.useState<{
        [key: string]: Contact;
    }>(initContacts);
    const onContactsChange = (contacts: { [key: string]: Contact }) => {
        console.log("setting contacts to: ", contacts);
        let contactsValue = setContacts(contacts);
        //ticketV.content = content;
        let f = getForm();
        f.contacts = contacts;
        console.log("setting fmer.contacts to: ", f, contacts);
        onFMERChange(f);
    };
    const handleRemoveContact = (toRemove: Contact) => {
        console.log("YIHHAAAAAA", contactsValue);
        const key = toRemove.metadata.id;
        if (key) {
            const { [key]: _, ...rest } = contactsValue;
            const newObj = rest;
            console.log(newObj);
            setContacts(newObj);
        }
    };

    const handleAddContact = (newContact: Contact) => {
        setContacts((prev) => {
            // avoid duplicates by id if you want
            /*
            if (prev.some((c) => c.metadata.id === newContact.metadata.id)) {
                return prev;
            }
            return [...prev, newContact];
            // */
            if (newContact.metadata.id) {
                prev[newContact.metadata.id] = newContact;
            }
            return prev;
        });
    };
    // content
    let initContent = fmer && fmer.content ? fmer.content : "";
    let [contentValue, setContent] = React.useState(initContent);
    const onContentChange = (content: string) => {
        /*let contentValue = */ setContent(content);
        //ticketV.content = content;
        let f = getForm();
        f.content = content;
        onFMERChange(f);
    };
    //const onSave = () => { };
    const getForm = () => {
        return {
            metadata: {
                id: fmer.metadata.id,
                old_id: fmer.metadata.old_id,
                user: { id: "1", name: "" },
                admin: null,
                organization: null,
                team: null,
                kprivate: true,
                created: {
                    id: "1",
                    name: "",
                    ts: created
                        ? created.toDate().toISOString()
                        : new Date().toISOString() /*fmer.metadata.created.ts*/,
                },
                modified: null,
                archived: null,
                deleted: null,
            },
            name: nameV, //fmer.name,
            extension: fmer.extension,
            tag: "",
            star: false,
            image_profile: fmer.image_profile,
            page_id: fmer.page_id,
            content: contentValue, //fmer.content ? fmer.content : "",
            contacts: contactsValue, //fmer.contacts,
            labels: [],
        };
    };
    return (
        <>
            <Box position="fixed" sx={sx}>
                <EditBar
                    id={fmer.metadata.id}
                    onSave={onSave}
                    page_id={fmer.page_id}
                />
            </Box>
            <Toolbar />
            <Link component={RLink} to={"/file/view/" + fmer.metadata.id}>
                View
            </Link>
            {" - "}
            <Link component={RLink} to={"/page/view/" + fmer.page_id}>
                Page
            </Link>
            {" - "}
            <Link
                component={RLink}
                to={"/file/by-filter?page_id=" + fmer.page_id}
            >
                File
            </Link>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <br />
                    <br />
                    <br />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField
                        label="filename"
                        fullWidth
                        value={nameV}
                        onChange={(e) => {
                            onFilenameChange(e.target.value);
                        }}
                    />
                    <br />
                    <br />
                    Is this it
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <DateTimePicker
                        label="created"
                        value={created}
                        slotProps={{ textField: { size: "small" } }}
                        onChange={(newValue) => onSetCreated(newValue)}
                        ampm={false}
                        format={"YYYY/MM/DD HH:mm"}
                    />
                </Grid>
                <Grid size={12}>
                    <ContactComplete
                        contacts={fmer.contacts}
                        onChange={onContactsChange}
                        onRemove={handleRemoveContact}
                        onAdd={handleAddContact}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        id="ticket-edit-content"
                        label="Content"
                        variant="standard"
                        defaultValue={initContent}
                        placeholder="Placeholder"
                        inputProps={{ style: { fontFamily: "courier new" } }}
                        multiline
                        fullWidth
                        onChange={(e) => {
                            onContentChange(e.target.value);
                        }}
                        sx={{ fontFamily: "courrier" }}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export function FileViewerLoading() {
    return <Box>Loading</Box>;
}

export function FileViewerFetching() {
    return <Box>Fetching</Box>;
}

export function FileViewerError({
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
}) {
    return <Box>Error</Box>;
}
